<template>
  <div class="menu animated fadeInLeftBig" v-if="isShow">
    <div class="menu-center">
      <div class="menu-header">
        <img
          src="../assets/return-icon.png"
          class="menu-header-arrow"
          v-if="isShowChildren"
          @click="returnMenu"
        />
        <span :style="{flex: 1}">菜单</span>
        <div class="menu-header-arrow" v-if="isShowChildren"></div>
      </div>
      <div v-if="!isShowChildren">
        <div class="menu-children" v-for="(item, index) in menuList" :key="index">
          <div
            class="menu-children-title"
            @click="goLink(item)"
            :style="{'border-right': item.category.length !== 0 ? '1px solid #c0c6c9' : ''}"
          >{{item.name}}</div>
          <img
            src="../assets/grey-arrow.png"
            v-if="item.category.length !== 0"
            class="menu-children-arrow"
            @click="showChildren(item)"
          />
        </div>
      </div>
      <div v-else class="animated fadeInRightBig">
        <div v-for="(item, index) in childrenList" :key="index">
          <div class="menu-children">
            <div
              class="menu-children-title"
              @click="goLink(item)"
              :style="{'border-right': item.category.length !== 0 ? '1px solid #c0c6c9' : ''}"
            >{{item.name}}</div>
            <img
              src="../assets/grey-arrow.png"
              v-if="item.category.length !== 0"
              class="menu-children-arrow"
              :style="{transform: selectShowIndex === null ? '' : 'rotate(90deg)'}"
              @click="showMore(index)"
            />
          </div>
          <div v-if="selectShowIndex === index">
            <div
              class="menu-children"
              v-for="(row, index) in item.category"
              :key="index"
              @click="goLink(row)"
            >{{row.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-chunk" @click="closeNav"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [],
      isShow: false,
      isShowChildren: false,
      childrenList: [],
      selectShowIndex: null
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    getMenuList() {
      this.$http.get("/open/cms/category/get-all-category").then(res => {
        this.menuList = res.data.data;
      });
    },
    goLink(item) {
      this.isShow = false;
      if (item.name === "网站首页") {
        this.$router.push({ name: "home" });
      } else {
        this.$store.commit("eidtBreadcrumb", item.id);
        this.$store.commit("eidtCategoryType", item.categoryType);
        this.$store.commit("eidtSelectMenuId", item.id);
        if (item.categoryType !== "list") {
          this.$http
            .get(`/open/cms/article?filter=categoryId||eq||${item.id}`)
            .then(res => {
              this.$store.commit("eidtArticleId", res.data.data[0].id);
              this.$router.push({ name: "articleList" });
            });
        } else {
          this.$router.push({ name: "articleList" });
        }
      }
    },
    showChildren(item) {
      this.isShowChildren = true;
      this.childrenList = item.category;
    },
    returnMenu() {
      this.isShowChildren = false;
    },
    showMore(index) {
      this.selectShowIndex === null
        ? (this.selectShowIndex = index)
        : (this.selectShowIndex = null);
    },
    showNav() {
      this.isShow = true;
    },
    closeNav() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.menu {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  &-center {
    width: 80%;
    height: 100%;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    background: #fff;
  }
  &-chunk {
    flex: 1;
  }
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-size: 18px;
    border-bottom: 1px solid #c0c6c9;
    padding: 10px 15px;
    &-arrow {
      width: 20px;
      height: 20px;
    }
  }
  &-children {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    padding: 0 0 0 20px;
    border-bottom: 1px solid #c0c6c9;
    &-title {
      height: 100%;
      flex: 1;
    }
    &-arrow {
      padding: 20px 20px;
    }
  }
}
</style>